import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import history from './modules/history'
import promission from './modules/promission'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    history,
    promission
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js